import { render, staticRenderFns } from "./EmployeeCoursesAdmin.vue?vue&type=template&id=2b0461ca&scoped=true"
import script from "./EmployeeCoursesAdmin.vue?vue&type=script&lang=js"
export * from "./EmployeeCoursesAdmin.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCoursesAdmin.vue?vue&type=style&index=0&id=2b0461ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0461ca",
  null
  
)

export default component.exports